function getBasePlacement(placement) {
  return placement.split('-')[0];
}

export { getBasePlacement as g };
//# sourceMappingURL=getBasePlacement-Cg7k2SRK.js.map
